'use client';

import { zodResolver } from '@hookform/resolvers/zod';

import { Box } from '@virginmediao2/momentum-nextjs/box';
import { Button } from '@virginmediao2/momentum-nextjs/button';
import {
  ErrorAlert,
  ErrorAlertsRef,
  FormInput,
} from '@virginmediao2/momentum-nextjs/forms';
import { useRouter } from 'next/navigation';
import { FC, ReactNode, useRef } from 'react';
import { useForm } from 'react-hook-form';

import { formSubmit } from './form-submit';
import {
  GetReleaseUpdatesUnsubscribeForm,
  getUpdatesUnsubscribeSchema,
} from './schema';

export interface GetReleaseUpdatesUnsubscribeProps {
  successUrl: string;
}

export const GetReleaseUpdatesUnsubscribe: FC<
  GetReleaseUpdatesUnsubscribeProps
> = ({ successUrl }) => {
  const errorAlertsRef = useRef<ErrorAlertsRef>(null);
  const router = useRouter();
  const {
    register,
    handleSubmit,
    setFocus,
    reset,
    formState: { errors, isSubmitting, isSubmitted, isValid },
  } = useForm<GetReleaseUpdatesUnsubscribeForm>({
    resolver: zodResolver(getUpdatesUnsubscribeSchema),
    defaultValues: {},
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
  });

  const onSubmit = async (data: GetReleaseUpdatesUnsubscribeForm) => {
    try {
      await formSubmit(data);
      reset();
      router.push(successUrl);
    } catch (e) {
      console.error('Get Release Updates Submission Error:', e);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box border={false} gap='lg' padding='xs'>
        {!isValid && isSubmitted && errors && (
          <ErrorAlert
            ref={errorAlertsRef}
            errors={errors}
            setFocus={setFocus}
          />
        )}

        <FormInput
          label='Email address*'
          id='emailAddr'
          placeholder='me@o2.com'
          error={errors?.emailAddr}
          disabled={isSubmitting}
          {...register('emailAddr')}
        />

        <Button disabled={isSubmitting} type='submit'>
          Submit
        </Button>
      </Box>
    </form>
  );
};
